/* eslint-disable react-hooks/exhaustive-deps */
import { differenceInSeconds } from 'date-fns';
import { useEffect, useMemo, useState } from 'react';
import { FaRegClock } from 'react-icons/fa';

// let tickTimeout: any = {};

// type CountdownProps = {
// 	deadline: unknown;
// }

export function Countdown({ ...props }) {
  // `hideIcon`: quem já mostra o relógio ao lado (notas de prazo da Home) não repete o ícone.
  // `urgentClassName`: cor do prazo de 1 dia ou menos. O padrão fica para as telas de fundo escuro;
  // a Home, em fundo claro, passa `text-urgent` para passar no AA.
  const { deadline, hideIcon, urgentClassName = 'text-[#ED2B48]' } = props;

  // const [result, setResult] = useState("00:00:00");

  const ONE_DAY = 60 * 60 * 24;
  const ONE_HOUR = 60 * 60;
  const ONE_MINUTE = 60;
  const [currentTime, setCurrentTime] = useState(new Date().getTime());

  const diffInSeconds = differenceInSeconds(deadline, currentTime);

  const getCoundown = () => {
    if (diffInSeconds <= 1) {
      return {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      };
    }
    const days = Math.floor(diffInSeconds / ONE_DAY);
    const hours = Math.floor((diffInSeconds - days * ONE_DAY) / ONE_HOUR);
    const minutes = Math.floor((diffInSeconds - days * ONE_DAY - hours * ONE_HOUR) / ONE_MINUTE);
    const seconds = diffInSeconds - days * ONE_DAY - hours * ONE_HOUR - minutes * ONE_MINUTE;
    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  const countdown = useMemo(getCoundown, [currentTime]);

  useEffect(() => {
    function tick() {
      const now = new Date().getTime();
      setCurrentTime(now);
    }
    const tickTimeout = setInterval(() => {
      tick();
    }, 1000);

    return () => {
      clearInterval(tickTimeout);
    };
  }, []);

  return (
    <>
      <span className={countdown.days <= 1 ? urgentClassName : ''}>
        {!hideIcon && <FaRegClock className="inline-block -mt-[2px] mr-1 ml-2" />}
        {countdown.days > 1 && <span>{countdown.days} dias, </span>}
        {countdown.days === 1 && <span>{countdown.days} dia, </span>}
        <span>{String(countdown.hours).padStart(2, '0')}:</span>
        <span>{String(countdown.minutes).padStart(2, '0')}:</span>
        <span>{String(countdown.seconds).padStart(2, '0')}</span>
      </span>
    </>
  );
}
